import { useState } from 'react';
import { useDebounce } from 'use-debounce';

// returns selectedFilters and functions to update them
const useCarriersFilters = () => {
  const defaultSelectedFilters = {
    search: '',
  };

  const initialSelectedFilters = defaultSelectedFilters;

  const [internalSelectedFilters, setInternalSelectedFilters] = useState(initialSelectedFilters);
  const [selectedFilters] = useDebounce(internalSelectedFilters, 500);

  const setSearch = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      search: value,
    });
  };

  return {
    selectedFilters,
    internalSelectedFilters,
    setSearch,
  };
};

export default useCarriersFilters;
